import {
  Box,
  Flex,
  Grid,
  Stack,
  Text,
  Spacer,
  HStack,
  Checkbox,
} from "@chakra-ui/react";
import dayjs from "dayjs";
import usePurchaseSupplier from "hooks/Supplier/use-purchase";
import { useState } from "react";

interface PurchaseSupplierGridMobileProps {
  data: any[];
  header: any[];
}

const PurchaseSupplierSkusGridMobile: React.FC<
  PurchaseSupplierGridMobileProps
> = ({ data }) => {
  const [isBoxVisible, setIsBoxVisible] = useState(false);
  const { handleCheckboxChange, idSelectDate } = usePurchaseSupplier();

  const toggleBoxes = () => {
    setIsBoxVisible((prevState) => !prevState);
  };
  return (
    <>
      <Grid
        templateColumns="repeat(auto-fit, minmax(200px, 1fr))"
        gap={4}
        p={4}
      >
        {data.map((item) => (
          <Flex key={item.storeId} direction="row">
            <Box
              borderWidth="3px"
              borderRadius="md"
              p={4}
              boxShadow="base"
              _hover={{ boxShadow: "xl" }}
              flex="1"
            >
              <Stack spacing={2}>
                <Box as="strong">
                  <Flex>
                    <Text color="gray.400">Centro: </Text>
                    <Spacer></Spacer>
                    <Text>
                      {item.storeId} - {item.storeDescription}
                    </Text>
                  </Flex>
                  <Flex>
                    <Text color="gray.400">Pedido: </Text>
                    <Spacer></Spacer>
                    <Text>{item.documentId}</Text>
                  </Flex>
                </Box>
                <Box>
                  <Box>
                    <Box onClick={toggleBoxes}>
                      <Text color="gray.400">Quantidade </Text>
                    </Box>

                    {isBoxVisible && (
                      <>
                        <Box>
                          <Flex>
                            <Text color="gray.400">Qtd Total: </Text>
                            <Spacer />
                            <Text>{item.orderedQuantity}</Text>
                          </Flex>
                        </Box>
                        <Box>
                          <Flex>
                            <Text color="gray.400">Qtd Entregue: </Text>
                            <Spacer />
                            <Text>{item.receivedQuantity}</Text>
                          </Flex>
                        </Box>
                        <Box>
                          <Flex>
                            <Text color="gray.400">Qtd Pendente: </Text>
                            <Spacer />
                            <Text>{item.quantityToSupply}</Text>
                          </Flex>
                        </Box>

                        <Box>
                          <Flex>
                            <Text color="gray.400">Qtd Agendada: </Text>
                            <Spacer />
                            <Text>{item.quantityScheduled}</Text>
                          </Flex>
                        </Box>
                        <Box>
                          <Flex>
                            <Text color="gray.400">
                              Qtd Pendente Agendamento:{" "}
                            </Text>
                            <Spacer />
                            <Text>{item.quantityPendingScheduling}</Text>
                          </Flex>
                        </Box>
                      </>
                    )}
                  </Box>
                </Box>
                <Box as="strong">
                  <Flex>
                    <Text color="gray.400">Data: </Text>
                    <Spacer></Spacer>
                    <Text>
                      {dayjs(item.expectedDeliveryDate).format("DD/MM/YYYY ")}
                    </Text>
                  </Flex>
                </Box>
                <Box as="strong">
                  <Flex>
                    <Text color="gray.400">Selecionar: </Text>
                    <Spacer></Spacer>
                    <HStack
                      spacing={2}
                      w="100%"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Spacer></Spacer>

                      <Checkbox
                        key={`table-action-1}`}
                        colorScheme="yellow"
                        isChecked={idSelectDate.includes(item.documentId)}
                        borderColor="blackAlpha.400"
                        alignItems="end"
                        onChange={() => {
                          handleCheckboxChange(item.documentId);
                        }}
                      />
                    </HStack>
                  </Flex>
                </Box>
                {/* Outras partes do seu código */}
              </Stack>
            </Box>
          </Flex>
        ))}
      </Grid>
    </>
  );
};

export default PurchaseSupplierSkusGridMobile;
